import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import cannedResponseBrowser from './cannedResponseBrowser.json';
import chatlist from './chatlist.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import teamsSettings from './teamsSettings.json';
// NOTICE: KAPTION-INTEGRATION - Secure Assignment screen
import secureAssignment from './secureAssignment.json';
import whatsappTemplates from './whatsappTemplates.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
// NOTICE: KAPTION-INTEGRATION
import playground from './playground.json';
import kaptionDebug from './kaptionDebug.json';
import kaptionFilePreview from './kaptionFilePreview.json';
import kaptionConversationTabs from './kaptionConversationTabs.json';
import kaptionAppUpdates from './kaptionAppUpdates.json';
import kaptionDesktopNotifications from './kaptionDesktopNotifications.json';
import kaptionWhatsapp2fa from './kaptionWhatsapp2fa.json';
// NOTICE: KAPTION-INTEGRATION - two-step-verification
import kaptionTwoStep from './kaptionTwoStep.json';
// NOTICE: KAPTION-INTEGRATION - security-center.UI.1
import kaptionSecurity from './kaptionSecurity.json';
import kaptionMcpConsent from './kaptionMcpConsent.json';
// NOTICE: KAPTION-INTEGRATION - ai-connectors
import kaptionAiConnectors from './kaptionAiConnectors.json';
// NOTICE: KAPTION-INTEGRATION - app-studio.UI.1
import kaptionAppStudio from './kaptionAppStudio.json';
import kaptionPartner from './kaptionPartner.json';
import aiSuggestions from './aiSuggestions.json';
import aiStudio from './aiStudio.json';
import kaptionPlatform from './kaptionPlatform.json';
import kaptionAccessTokens from './kaptionAccessTokens.json';
import kaptionDeliveryWebhooks from './kaptionDeliveryWebhooks.json';
import kaptionResponsePolicies from './kaptionResponsePolicies.json';
// NOTICE: KAPTION-INTEGRATION - Feature Management (client-managed permission layer)
import featureManagement from './featureManagement.json';
// NOTICE: KAPTION-INTEGRATION - home-dashboard-app.WEB.8
import kaptionHomeScreen from './kaptionHomeScreen.json';
// NOTICE: KAPTION-INTEGRATION - WhatsApp Template Management
import whatsappTemplateManagement from './whatsappTemplateManagement.json';
// NOTICE: KAPTION-INTEGRATION - Activity message i18n
import activityMessages from './activityMessages.json';
// NOTICE: KAPTION-INTEGRATION - reply-template-picker
import kaptionReplyTemplate from './kaptionReplyTemplate.json';
// NOTICE: KAPTION-INTEGRATION - contact-first-conversation
import kaptionContactFirst from './kaptionContactFirst.json';
// NOTICE: KAPTION-INTEGRATION - whatsapp-calling.WEB.7
import kaptionCalls from './kaptionCalls.json';
// NOTICE: KAPTION-INTEGRATION - whatsapp-flows
import kaptionWhatsappFlows from './kaptionWhatsappFlows.json';
// NOTICE: KAPTION-INTEGRATION - Asistentes (agent providers)
import kaptionAssistants from './kaptionAssistants.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...cannedResponseBrowser,
  ...chatlist,
  ...components,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...teamsSettings,
  ...secureAssignment,
  ...whatsappTemplates,
  ...contentTemplates,
  ...mfa,
  // NOTICE: KAPTION-INTEGRATION
  ...playground,
  ...kaptionDebug,
  ...aiSuggestions,
  ...aiStudio,
  ...kaptionPlatform,
  ...kaptionAccessTokens,
  ...kaptionDeliveryWebhooks,
  ...kaptionResponsePolicies,
  ...kaptionFilePreview,
  ...kaptionConversationTabs,
  ...kaptionAppUpdates,
  ...kaptionDesktopNotifications,
  ...kaptionWhatsapp2fa,
  ...kaptionTwoStep,
  ...kaptionSecurity,
  ...kaptionMcpConsent,
  ...kaptionAiConnectors,
  ...kaptionAppStudio,
  ...kaptionPartner,
  // NOTICE: KAPTION-INTEGRATION - Feature Management (client-managed permission layer)
  ...featureManagement,
  ...kaptionHomeScreen,
  // NOTICE: KAPTION-INTEGRATION - WhatsApp Template Management
  ...whatsappTemplateManagement,
  // NOTICE: KAPTION-INTEGRATION - Activity message i18n
  ...activityMessages,
  ...kaptionReplyTemplate,
  ...kaptionContactFirst,
  ...kaptionCalls,
  ...kaptionWhatsappFlows,
  ...kaptionAssistants,
};
